document.addEventListener('DOMContentLoaded', () => {
	if (!window.mwf) {
		return;
	}

	let hash = window.location.hash;

	// Use JS init so we have access to the moray methods. Seems like moray does
	// not use attributes for state, it's internal.
	const showMoreLessElements = document.querySelectorAll('.show-more-show-less');

	if (!showMoreLessElements.length) {
		return;
	}

	// Create an instance for each show-more element and store a reference.
	const instanceMap = new Map();
	showMoreLessElements.forEach(el => {
		const instance = new window.mwf.ShowMoreShowLess({ el });
		instanceMap.set(el, instance);
	});

	// Support on-load.
	// -----------------------------------------------------------------------
	if (hash.length > 1) {
		try {
			// Ensure any hash is a valid selector.
			let hashValue = hash.substring(1);
			let decodedHash = decodeURIComponent(hashValue);
			const safeSelector = `#${CSS.escape(decodedHash)}`;

			showMoreLessElements.forEach(item => {
				const toggleableContent = item.querySelector('.show-more-show-less-toggleable-content');

				if (toggleableContent && toggleableContent.querySelector(safeSelector)) {
					const instance = instanceMap.get(item);
					if (instance) {
						instance.show();
					}
				}
			});
		} catch (e) {
			console.error("Malformed URL hash for decoding:", e);
		}
	}

	// Support clicking # links:
	// -----------------------------------------------------------------------
	const content = document.querySelector('.single-post__content');

	if (content) {
		const links = content.querySelectorAll('[href*="#"]');

		// Check if the link is internal (same page):
		links.forEach(link => {
			const href = link.getAttribute('href');
			if (!href.startsWith('#')) {
				return;
			}

			link.addEventListener('click', () => {
				const target = content.querySelector(href);
				if (!target) {
					return;
				}

				const container = target.closest('.show-more-show-less');
				if (container) {
					const instance = instanceMap.get(container);
					if (instance) {
						instance.show();
					}
				}
			});
		});
	}

	// Adding one enhancement - on close, scroll to the close button:
	const instances = window.mwf.ShowMoreShowLess.getInstances();
	instances.forEach(instance => {
		if (!instance.control) {
			return;
		}

		instance.control.addEventListener('onHide', (e) => {
			// e is the toggle button.
			e.target.scrollIntoView();
		});
	});
});
